import { createFileRoute } from '@tanstack/react-router';
import { ProfileEditorPage } from '../../features/directory';

export const Route = createFileRoute('/portal/directory/profile')({ component: ProfileEditorPage });
